import { useAuthToken } from "./useAuthToken";
export const useLogout = () => {
  const [, , removeAuthToken] = useAuthToken();

  const logout = () => {
    removeAuthToken();
  };
  return logout;
};
